import request from '@/common/request'
import file from '@/common/fileDownload'
/** 
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
  createDeviceInfo: (dynaSeg, data, params) => {
    return request({
      url: '/deviceInfo',
      method: 'post',
      data,
      params
    })
  },
  deleteDeviceInfo: (dynaSeg, data, params) => {
    return request({
      url: `/deviceInfo/${dynaSeg.id}`,
      method: 'delete',
      data,
      params
    })
  },
  updateDeviceInfo: (dynaSeg, data, params) => {
    return request({
      url: `/deviceInfo/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  queryDeviceInfo: params => {
    return request({
      url: '/deviceInfo',
      method: 'get',
      params
    })
  },
  listAllAsTree:()=>{
    return request({
      url: '/deviceInfo/listAllAsTree',
      method: 'get'
    })
  },
  startDevice: (dynaSeg, data) => {
    return request({
      url: `/terminalInfo/startDevice/${dynaSeg.id}`,
      method: 'put',
      data
    })
  },
  pauseConfig:data =>{
    return request({
      url: '/pauseConfig',
      method: 'post',
      data
    })
  },
  deviceScrap: (dynaSeg, data) => {
    return request({
      url: `/deviceInfo/deviceScrap/${dynaSeg.id}`,
      method: 'put',
      data
    })
  },
  deviceStop: (dynaSeg, data) => {
    return request({
      url: `/deviceInfo/deviceStop/${dynaSeg.id}`,
      method: 'put',
      data
    })
  },
  deviceMove: (dynaSeg, data) => {
    return request({
      url: `/deviceInfo/deviceMove/${dynaSeg.id}`,
      method: 'put',
      data
    })
  },
  checkIpAddr:params =>{
    return request({
      url: '/terminalInfo/checkIpAddr',
      method: 'get',
      params
    })
  },
  deviceInfoExport:params =>{
    file.fileDownload('/deviceInfo/downDataExcelFile',params);
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/deviceInfo.js